export const SEARCH_INPUT_NAME = 'search-input';
